import Page, { PageProps } from '@/components/page';
import RouterTabs from '@/components/router-tabs';
import OrgPolicyIntentsForm from '@/pages/config/org-policy/intents-form';
import OrgPolicySensitiveDataForm from '@/pages/config/org-policy/sensitive-data-form';
import { FC } from 'react';
import ServiceAccessForm from './service-access-form';
import PortalForm from './portal-form';
import OrgMcpAccessForm from './mcp-access-form';
import useFeature from '@/hooks/use-feature.hook';
import { Navigate } from '@tanstack/react-router';

const OrgPolicyPage: FC<PageProps> = () => {
  const { hasPolicyV2 } = useFeature();

  if (hasPolicyV2) {
    return <Navigate to="/config/policy/scoped" />;
  }

  return (
    <Page title="Default Policy">
      <RouterTabs
        panels={[
          {
            label: 'Services',
            path: 'services',
            component: <ServiceAccessForm />,
          },
          {
            label: 'MCP Tools',
            path: 'mcp-tools',
            component: <OrgMcpAccessForm />,
          },
          {
            label: 'Sensitive Data',
            path: 'sensitive-data',
            component: <OrgPolicySensitiveDataForm />,
          },
          {
            label: 'Classifiers',
            path: 'classifiers',
            component: <OrgPolicyIntentsForm />,
          },
          { label: 'Portal', path: 'portal', component: <PortalForm /> },
        ]}
      />
    </Page>
  );
};

export default OrgPolicyPage;
